/**
 * 대리 로그인 시작 — 새 탭이 대상 계정으로 열린다 (260917-realm-sessions-impersonation).
 *
 * 토큰은 **그 탭의 sessionStorage 에만** 산다. 쿠키를 심지 않으므로 이 탭(운영자)도, 같은 브라우저의
 * 고객 로그인도 그대로다. 화면 둘이 같은 절차를 각자 구현하면 갈리므로 여기 한 곳에 둔다.
 */
import { auth } from '@geo-admin/shared/contract/api/index.ts';
import { call } from './call.ts';
import { openImpersonationTab } from './impersonation.ts';
import { useMe } from './me.ts';

export function useImpersonate(): (userId: string) => Promise<void> {
  const me = useMe();
  return async (userId: string) => {
    try {
      const res = await call(auth.startImpersonation, { params: { id: userId } });
      const opened = openImpersonationTab({
        token: res.token,
        targetEmail: res.target.email,
        adminEmail: me.data?.email ?? '',
      });
      if (!opened) alert('새 탭이 차단됐습니다. 이 사이트의 팝업을 허용한 뒤 다시 눌러 주세요');
    } catch (e) {
      alert((e as Error).message);
    }
  };
}
